export default "__VITE_ASSET__BgWlc9VG__"